import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { store, persistor } from './redux/configureStore';
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from "antd";
import { BrowserRouter } from "react-router-dom";
import locale from 'antd/locale/ru_RU';
import dayjs from 'dayjs';
import App from './core/App';
import { antdToken, antdComponents } from "./core/styles";
import moment from 'moment';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import 'dayjs/locale/ru';
import 'moment/locale/ru';

// Устанавливаем локали для даты
moment.locale('ru');
dayjs.locale('ru');

// DOM root и react root
const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

/*
 * Хелпер для styled-components: разрешаем/запрещаем передачу пропов в DOM-элементы.
 * Для строковых `target` (тэги DOM) используем `isPropValid`, чтобы не передавать
 * неизвестные пропы в нативные элементы (предотвращает React warnings).
 */
const shouldForwardStyledProp = (propName, target) => {
  if (typeof target === 'string') {
    return isPropValid(propName);
  }

  return true;
};

// Рендер приложения с провайдерами
root.render(
  <StyleSheetManager shouldForwardProp={shouldForwardStyledProp}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider
          locale={locale}
          theme={{
            token: antdToken,
            components: antdComponents,
            cssVar: true,
          }}
        >
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigProvider>
      </PersistGate>
    </Provider>
  </StyleSheetManager>
);
